export default "__VITE_ASSET__B5pqhg3g__"